export const JOBS_POLL_ACTIVE_MS = 4000;
export const JOBS_POLL_IDLE_MS = 8000;
export const JOBS_POLL_HIDDEN_MS = 45000;
/** Keep polling quickly after new jobs appear (e.g. scheduler enqueue). */
export const JOBS_POLL_BURST_WINDOW_MS = 60000;

export function pollIntervalMs(hasActive: boolean, visible: boolean): number {
  if (!visible) return JOBS_POLL_HIDDEN_MS;
  if (hasActive) return JOBS_POLL_ACTIVE_MS;
  return JOBS_POLL_IDLE_MS;
}
